import { useState, useRef } from "react"
import { useNavigate } from "react-router-dom"
import HeaderWrapperMobile from "../header-wrapper-mobile"
import Flex from "../../../../components/flex"
import ImageBox from "@/components/image-box"
import { langStore } from "@/stores/lang-store"
import { overviewStore } from "@/routes/apt/[apt_code]/overview/overview-store"
import { aptSearchStore } from "@/routes/select/apt/apt-search-store"
import TabButton from "../../../../components/buttons/tab-button"
import { headerBundle } from "./overview-header-const"
import Wrapper from "@/components/wrapper"

const OverviewHeaderMobile = () => {
  const navigate = useNavigate()
  const { lang } = langStore()

  const { selectedTab, tabClick } = overviewStore()
  const pickApt = aptSearchStore((s) => s.pickApt)

  const [tempTab, setTempTab] = useState(selectedTab)
  const [open, setOpen] = useState(false)
  const rootRef = useRef(null)

  const handleConfirm = () => {
    tabClick(tempTab)
    setOpen(false)
  }

  return (
    <HeaderWrapperMobile position="sticky">
      <Flex className="items-center w-full justify-between" gap={2}>
        <div
          className="flex items-center gap-3 cursor-pointer hover:opacity-70 transition-opacity"
          onClick={() => navigate("/select/apt")}
        >
          <ImageBox
            src="/images/toicos-logo-a.png"
            className="w-8 h-8 object-contain"
            alt="Toicos Logo"
          />
          <h1 className="font-bold text-lg text-slate-800 truncate max-w-[50vw]">
            {pickApt.apt_name}
          </h1>
        </div>

        <Flex className="items-center relative mr-3" gap={3}>
          <div ref={rootRef} className="relative">
            <button
              onClick={() => setOpen((v) => !v)}
              className={`h-10 w-10 rounded-md flex items-center justify-center cursor-pointer transition-colors
                ${open ? "bg-blue-100 text-blue-600" : "bg-transparent text-gray-700"}`}
            >
              <svg
                viewBox="0 0 24 24"
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <circle cx="11" cy="11" r="7" />
                <path d="M20 20l-3.5-3.5" />
              </svg>
            </button>

            {open && (
              <div
                className="fixed left-0 right-0 z-50 px-4 mt-2"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="bg-white rounded-xl border border-gray-200 shadow-2xl p-5 w-full">
                  <div className="flex flex-col gap-5">
                    <div className="w-full">
                      <p className="text-xs font-semibold text-gray-400 mb-3 ml-1">
                        {headerBundle.mobileSelect[lang] || "분석 기간 선택"}
                      </p>
                      <Wrapper.tab>
                        {headerBundle.tabs.map((tab) => (
                          <TabButton
                            key={tab.id}
                            onClick={() => setTempTab(tab)}
                            isActive={tempTab.id === tab.id}
                          >
                            {tab.label[lang]}
                          </TabButton>
                        ))}
                      </Wrapper.tab>
                    </div>

                    <button
                      onClick={handleConfirm}
                      className="w-full py-2.5 rounded-lg bg-blue-600 text-white font-bold text-sm hover:bg-blue-700 transition-colors shadow-md"
                    >
                      {headerBundle.search[lang]}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </Flex>
      </Flex>
    </HeaderWrapperMobile>
  )
}

export default OverviewHeaderMobile
